import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24a5810b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pill-container" }
const _hoisted_2 = {
  key: 0,
  class: "pill__content"
}
const _hoisted_3 = { class: "pill__title" }
const _hoisted_4 = {
  key: 0,
  class: "pill__description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['pill', { 'not-watched': !_ctx.watched }]),
      style: _normalizeStyle(`background-image: url(${_ctx.background}) !important;`),
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pressing && _ctx.pressing(...args))),
      onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moving && _ctx.moving(...args))),
      onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.releasing && _ctx.releasing(...args))),
      onTouchstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pressing && _ctx.pressing(...args))),
      onTouchmove: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moving && _ctx.moving(...args))),
      onTouchend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.releasing && _ctx.releasing(...args)))
    }, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
            false
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 38)
  ]))
}